import { api, apiMipe } from '@/core/api/';

import ServiceTypeCategories from '@/utils/constants/serviceTypeCategories.js';

export const getPractitionerTypes = async () => {
  return await apiMipe.get(`api/code/practitionertypes`);
};

export const getSpecialtyTypes = async () => {
  return await apiMipe.get(`api/code/specialtytypes`);
};

export const getSpecialistSpecialtyTypes = async () => {
  return await apiMipe.get(`api/code/specialistspecialtytypes`);
};

export const getSpecialtyDisciplineTypes = async (specialtyTypeId) => {
  return await apiMipe.get(
    `api/code/specialistspecialtyDisciplines/${specialtyTypeId}`
  );
};

export const getUniversities = async () => {
  return await apiMipe.get(`api/code/universities`);
};

export const getAddressTypes = async () => {
  return await apiMipe.get(`/api/code/addresstypes`);
};

export const getCompanyTypes = async () => {
  return await apiMipe.get('api/code/companyTypes');
};

export const getServiceTypes = async () => {
  return await apiMipe.get(`api/code/servicetypes`);
};

export const getDisciplineTypes = (serviceTypeId, validForFlag) => {
  return apiMipe.get(`api/code/getcodedisciplinetypes/`, {
    params: {
      serviceTypeId: serviceTypeId,
      validForFlag: validForFlag,
    },
  });
};

export const getAllDisciplineTypes = async (params) => {
  let url = `api/code/disciplinetypes?`;

  params = params || {};
  params.serviceTypeIds = params.serviceTypeIds || [];
  params.categories = params.categories || [];
  params.disciplineIds = params.disciplineIds || [];
  params.modules = params.modules || [];

  params.serviceTypeIds.forEach((serviceTypeId) => {
    url += `&serviceTypeIds=${serviceTypeId}`;
  });

  params.categories.forEach((categoryId) => {
    url += `&categories=${categoryId}`;
  });

  params.disciplineIds.forEach((disciplineId) => {
    url += `&disciplineIds=${disciplineId}`;
  });

  params.modules.forEach((moduleId) => {
    url += `&modules=${moduleId}`;
  });

  url = url.replace('?&', '?');

  const { status, data: response } = await apiMipe.get(url);
  return status !== 200 ? [] : response;
};

export const getContractServiceTypes = async () => {
  return await apiMipe.get(
    `api/code/servicetypes?categoryId=${ServiceTypeCategories.ContractService}`
  );
};

export const getServiceLocationServiceTypes = async () => {
  return await apiMipe.get(
    `api/code/servicetypes?categoryId=${ServiceTypeCategories.ServiceLocation}`
  );
};

export const getCodeServiceTypes = async (categoryId) => {
  return await apiMipe.get('/api/code/servicetypes', {
    params: { categoryId },
  });
};

export const getTypePlaces = async (code) => {
  return await apiMipe.get(`api/code/locationtypes/${code}`);
};

export const getSchoolTypes = async () => {
  return await apiMipe.get(`api/code/schooltypes`);
};

/**
 *
 * @param {
 * DisciplineTypeId,
 * ValidForRemedioProvisionalFlag,
 * ValidForPEIFlag,
 * ValidForEFAFlag,
 * ValidForEducationServiceFlag,
 * ValidForTherapyAndOtherServicesFlag,
 * Screen
 * } payload
 * @returns
 */
export const getServiceModalities = async (payload) => {
  if (payload !== undefined) {
    return apiMipe.get('api/code/servicemodalities', {
      params: payload,
    });
  }
  return await apiMipe.get('api/code/servicemodalities');
};

export const getTherapyDurations = async () => {
  return await apiMipe.get('api/code/therapydurations');
};

export const getTherapyDurationsForTherapies = async () => {
  return await apiMipe.get('api/pei/therapyduration');
};

export const getTherapyPeriod = () => apiMipe.get('api/code/therapyperiod');
export const getPeriods = () => apiMipe.get('api/code/periods');

export const getRecommendationReason = () =>
  apiMipe.get('api/code/interventionrecommendationreason');

export const getRecommendationReasonRegister = (reasonId) =>
  apiMipe.get(`api/code/interventionrecommendationreasonregister/${reasonId}`);

export const getDisciplinesForTherapy = () =>
  apiMipe.get(`api/code/disciplines/validForTherapy`);

export const getServices = async (
  serviceTypeIds,
  categories,
  modules,
  disciplineTypes = null
) => {
  let qs = '';

  if (serviceTypeIds != undefined && serviceTypeIds != null) {
    for (let i = 0; i < serviceTypeIds.length; i++) {
      qs += `serviceTypeIds=${serviceTypeIds[i]}&`;
    }
  }

  if (disciplineTypes != undefined && disciplineTypes != null) {
    for (let i = 0; i < disciplineTypes.length; i++) {
      qs += `disciplineIds=${disciplineTypes[i]}&`;
    }
  }

  if (categories != undefined && categories != null) {
    for (let i = 0; i < categories.length; i++) {
      qs += `categories=${categories[i]}&`;
    }
  }

  if (modules != undefined && modules != null) {
    for (let i = 0; i < modules.length; i++) {
      qs += `modules=${modules[i]}&`;
    }
  }

  if (qs.length > 0) qs = qs.slice(0, -1);

  // In MIPE DB the "discipline types" are in fact the "services"
  return await apiMipe.get(`api/code/disciplinetypes?${qs}`);
};

export const getFrequencyType = () => apiMipe.get('api/code/frequencytype');

export const getPeiCode = (codeType, longName) =>
  apiMipe.get(`api/code/getpeicode`, {
    params: {
      codeType,
      longName,
    },
  });

export const getDisciplineTypesSplit = () =>
  apiMipe.get('api/code/getDisciplineTypeServices');

export const getPayrollReceiveTypeAsync = async (includeAll = false) =>
  apiMipe.get('api/code/payrollreceivetype', {
    params: {
      includeAll,
    },
  });

export const getAdjustmentReasons = async () => {
  return await apiMipe.get(`api/code/adjustmentreasons`);
};

export const getFollowUpCategories = async () => {
  return await apiMipe.get(`api/code/followupcategories`);
};

export const getCardManagementStatus = async () => {
  return await apiMipe.get(`api/code/cardmanagementstatus`);
};

export const getCardDeliveryMethods = async () => {
  return await apiMipe.get(`api/code/carddeliverymethod`);
};

export const getCardClaimTypes = async () => {
  return await apiMipe.get(`api/code/cardclaimtype`);
};

export const getCardClaimReasons = async () => {
  return await apiMipe.get(`api/code/cardclaimreason`);
};
export const getCardReceptionTypes = async () => {
  return await apiMipe.get(`api/code/cardreceptiontype`);
};
export const getCardManagementTypes = async () => {
  return await apiMipe.get(`api/code/getcardmanagementtype`);
};
export const getCardCancellationReasons = async () => {
  return await apiMipe.get(`api/code/cardcancellationreasons`);
};
export const getCardDeliveryTypes = async () => {
  return await apiMipe.get(`api/code/getcarddeliverytype`);
};
export const getCardClaimRelationships = async (filter) => {
  return await apiMipe.post(`api/code/card/relationship`, filter);
};

export const getApplications = () => apiMipe.get(`api/code/application`);

export const getReevaluationTimes = () =>
  apiMipe.get('api/code/reevaluationtimes');

export const getEvaluationtypes = () =>
  apiMipe.get('api/code/getrequestmanagementevaluationtypes');
export const getHiringTypes = () => apiMipe.get('api/code/hiringtypes');

export const getProposalContractDocumentTypes = async () => {
  return await api.get(`api/code/proposalcontractdocumenttypes`);
};

export const getEligibilityStatus = async () => {
  return await api.get(`api/code/eligibility-types`);
};
